
import TextTitle from 'widget-components/components/TextTitle/TextTitle.vue'
import TextPlain from 'widget-components/components/TextPlain/TextPlain.vue'
import TextCopiable from 'widget-components/components/TextCopiable/TextCopiable.vue'
import GraphicImage from 'widget-components/components/GraphicImage/GraphicImage.vue'
import ActionButton from 'widget-components/components/ActionButton/ActionButton.vue'
import DisplayDocument from 'widget-components/components/DisplayDocument/DisplayDocument.vue'
import Divider from 'widget-components/components/Divider/Divider.vue'
import EmptySpace from 'widget-components/components/EmptySpace/EmptySpace.vue'
import InputCheckbox from 'widget-components/components/InputCheckbox/InputCheckbox.vue'
import InputCheckboxList from 'widget-components/components/InputCheckboxList/InputCheckboxList.vue'
import InputConsentList from 'widget-components/components/InputConsentList/InputConsentList.vue'
import Country from 'widget-components/components/Country/Country.vue'
import InputCountry from 'widget-components/components/InputCountry/InputCountry.vue'
import InputDate from 'widget-components/components/InputDate/InputDate.vue'
import InputDateTime from 'widget-components/components/InputDateTime/InputDateTime.vue'
import InputDigit from 'widget-components/components/InputDigit/InputDigit.vue'
import InputDocument from 'widget-components/components/InputDocument/InputDocument.vue'
import InputFile from 'widget-components/components/InputFile/InputFile.vue'
import InputDropdown from 'widget-components/components/InputDropdown/InputDropdown.vue'
import InputEmail from 'widget-components/components/InputEmail/InputEmail.vue'
import InputNumber from 'widget-components/components/InputNumber/InputNumber.vue'
import InputPhoneNumber from 'widget-components/components/InputPhoneNumber/InputPhoneNumber.vue'
import InputRadio from 'widget-components/components/InputRadio/InputRadio.vue'
import InputSlider from 'widget-components/components/InputSlider/InputSlider.vue'
import InputText from 'widget-components/components/InputText/InputText.vue'
import ListView from 'widget-components/components/ListView/ListView.vue'
import ProgressBar from 'widget-components/components/ProgressBar/ProgressBar.vue'
import SelectionList from 'widget-components/components/SelectionList/SelectionList.vue'
import Stepper from 'widget-components/components/Stepper/Stepper.vue'
import Container from 'widget-components/components/Container/Container.vue'
import TabbedContainer from 'widget-components/components/TabbedContainer/TabbedContainer.vue'
import Graph from 'widget-components/components/Graph/Graph.vue'
import Toggle from 'widget-components/components/Toggle/Toggle.vue'
import InputTextArea from 'widget-components/components/InputTextarea/InputTextarea.vue'
import RepeatableContainer from 'widget-components/components/RepeatableContainer/RepeatableContainer.vue'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'
import CheckTrigger from 'widget-components/components/InputCheckbox/CheckTrigger.vue'
import InputConsent from 'widget-components/components/InputConsent/InputConsent.vue'
import InputFileUpload from 'widget-components/components/InputFileUpload/InputFileUpload.vue'
import Position from 'widget-components/components/Position/Position.vue'
import Navigation from 'widget-components/components/Navigation/Navigation.vue'
import LanguageSelector from 'widget-components/components/LanguageSelector/LanguageSelector.vue'

export default {
    ActionButton,
    EmptySpace,
    ErrorText,
    GraphicImage,
    CheckTrigger,
    InputCheckbox,
    InputCheckboxList,
    Toggle,
    InputConsent,
    InputConsentList,
    InputDate,
    InputDateTime,
    InputDigit,
    InputFileUpload,
    InputFile,
    InputDocument,
    InputDropdown,
    InputEmail,
    InputNumber,
    InputPhoneNumber,
    InputRadio,
    InputSlider,
    InputText,
    InputTextArea,
    Position,
    SelectionList,
    TextCopiable,
    TextPlain,
    TextTitle,
    DisplayDocument,
    ProgressBar,
    Stepper,
    Divider,
    ListView,
    Container,
    Country,
    InputCountry,
    LanguageSelector,
    RepeatableContainer,
    TabbedContainer,
    Graph,
    Navigation,
}
